export enum CarrierBillingAccountType {
  ThirdParty = "THIRD_PARTY",
  Receiver = "RECEIVER",
}
